import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PrincipalLayouts } from "../../layouts"
import { NetworkingTable } from '../components/networking/NetworkingTable';
import { fetchData } from '../helpers/getData/fetchData';

export const NetworkingList = () => {

    const {t} = useTranslation('global')
    const [networkingList, setNetworkingList] = useState('loading')
    const { user } = useSelector(state => state.auth)

    useEffect(() => {
        fetchData(setNetworkingList, '/user/getNetworkingList', t);
    }, [user, t])

    return (
      <PrincipalLayouts>
        <Box >
          {
            networkingList !== 'loading' &&
            <NetworkingTable rows={networkingList}  />
          }
        </Box>
      </PrincipalLayouts>
    )
}